const cardItems = [
  {
    id: 1,
    title: '2026年中黑料大盘点：这些网红翻车翻得最惨',
    desc: '从人设崩塌到全网封杀，盘点今年上半年那些让人瞠目结舌的网红翻车事件，看看谁是最大输家。',
    tag: '年度盘点',
    time: '3天前',
    src: 'https://readdy.ai/api/search-image?query=dramatic%20warm%20abstract%20textures%20against%20dark%20background%20coral%20red%20and%20amber%20highlights%20artistic%20editorial%20photography%20style%20cinematic%20mood%20professional%20quality&width=800&height=500&seq=card-img-01&orientation=landscape',
  },
  {
    id: 2,
    title: '选秀节目到底有多少黑幕？前工作人员实名爆料',
    desc: '一位曾参与多档选秀节目的前工作人员实名曝光行业内幕，揭秘那些不为人知的暗箱操作。',
    tag: '综艺争议',
    time: '5天前',
    src: 'https://readdy.ai/api/search-image?query=minimal%20abstract%20composition%20warm%20coral%20tones%20gentle%20gradient%20dark%20backdrop%20modern%20clean%20aesthetic%20editorial%20style%20soft%20lighting&width=800&height=500&seq=card-img-02&orientation=landscape',
  },
  {
    id: 3,
    title: '品牌代言人突然解约的背后：那些不为人知的博弈',
    desc: '近期多位明星突然与品牌解约，背后究竟隐藏着怎样的商业博弈和利益冲突？深度解析。',
    tag: '品牌塌房',
    time: '1周前',
    src: 'https://readdy.ai/api/search-image?query=abstract%20flowing%20warm%20colors%20deep%20coral%20red%20and%20amber%20against%20dark%20background%20artistic%20motion%20blur%20cinematic%20feeling%20dramatic%20atmosphere&width=800&height=500&seq=card-img-03&orientation=landscape',
  },
  {
    id: 4,
    title: '直播带货行业大洗牌：谁将成为下一个顶流？',
    desc: '直播带货行业正经历前所未有的格局变化，新老主播交替加速，行业规范日趋严格。',
    tag: '直播内幕',
    time: '1周前',
    src: 'https://readdy.ai/api/search-image?query=modern%20abstract%20warm%20light%20rays%20piercing%20dark%20background%20coral%20orange%20glow%20atmospheric%20editorial%20style%20professional%20quality%20dramatic&width=800&height=500&seq=card-img-04&orientation=landscape',
  },
  {
    id: 5,
    title: '素人爆料：我在某知名企业工作的那些黑暗日子',
    desc: '一位前员工以素人身份爆料在某知名企业工作的真实经历，揭露职场霸凌和违法用工等问题。',
    tag: '素人爆料',
    time: '2周前',
    src: 'https://readdy.ai/api/search-image?query=abstract%20minimal%20warm%20gradient%20dark%20to%20coral%20red%20modern%20sleek%20background%20artistic%20composition%20editorial%20quality%20subtle%20texture&width=800&height=500&seq=card-img-05&orientation=landscape',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
              <i className="ri-article-line"></i> 深度解读
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              热门专题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
              精选深度专题报道，全方位解读热门八卦事件背后的故事
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cardItems.map((card) => (
              <div
                key={card.id}
                className={`group bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:shadow-lg transition-all duration-300 ${
                  card.id === 1 || card.id === 2
                    ? 'lg:col-span-1'
                    : card.id === 3
                      ? 'lg:col-span-1'
                      : 'lg:col-span-1'
                }`}
              >
                {/* Image */}
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={card.src}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                      {card.tag}
                    </span>
                  </div>
                </div>
                {/* Content */}
                <div className="p-5">
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                    {card.desc}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500">
                      <i className="ri-time-line mr-1"></i>{card.time}
                    </span>
                    <span className="text-xs text-primary-500 font-medium group-hover:underline whitespace-nowrap">
                      阅读全文 <i className="ri-arrow-right-line ml-0.5"></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}